import { createFeature, createReducer, createSelector, on } from '@ngrx/store';
import { SignUpEffectActions, SignUpFormActions } from './sign-up.actions';
import { Auth0Error } from './models/auth0-error.model';
import { SignUpErrorCode } from './models/sign-up-error-codes';

interface State {
  error: Auth0Error;
  submitting: boolean;
}

const initialState: State = {
  error: null,
  submitting: false,
};

export const signUpFeature = createFeature({
  name: 'signUp',
  reducer: createReducer(
    initialState,
    on(SignUpFormActions.signUpClicked, (state) => ({
      ...state,
      error: null,
      submitting: true,
    })),
    on(SignUpEffectActions.signUpSucceeded, (state) => ({
      ...state,
      submitting: false,
    })),
    on(SignUpEffectActions.signUpErrored, (state, { error }) => ({
      ...state,
      error,
      submitting: false,
    })),
    on(SignUpFormActions.viewDestroyed, () => ({
      ...initialState,
    })),
  ),
  extraSelectors: ({ selectError }) => ({
    selectUserExistsError: createSelector(
      selectError,
      (error) => error && error.code === SignUpErrorCode.UserExists,
    ),
    selectOtherError: createSelector(
      selectError,
      (error) => error && error.code !== SignUpErrorCode.UserExists,
    ),
  }),
});
